import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Uporabljamo piškotke',
    description:
      'Za delovanje te izkušnje uporabljamo piškotke in podobne tehnologije. Nujno potrebni piškotki so vedno aktivni.',
    allow_label: 'Sprejmi vse piškotke',
    reject_label: 'Samo nujno potrebni',
    settings_label: 'Nastavitve piškotkov',
    policy_link_label: 'Pravilnik o zasebnosti in piškotkih',
    categories_label: 'Kategorije',
    always_on_label: 'Vedno aktivno',
    required_label: 'Obvezno',
    save_preferences_label: 'Shrani nastavitve',
    close_label: 'Zapri',
    allow_all_optional_categories_label: 'Dovoli vse izbirne kategorije',
    settings_title: 'Nastavitve piškotkov',
    settings_description:
      'Za delovanje te izkušnje uporabljamo piškotke in podobne tehnologije. Nujno potrebni piškotki so vedno aktivni.',
    save_error: 'Vaše izbire glede zasebnosti nismo mogli shraniti. Poskusite znova.'
  },
  categories: {
    strictly_necessary: {
      name: 'Nujno potrebni',
      purpose: 'Potrebni so za delovanje te izkušnje in jih ni mogoče izklopiti.'
    },
    analytics: {
      name: 'Analitika',
      purpose: 'Merijo, kako obiskovalci uporabljajo to izkušnjo, da se izboljša delovanje.'
    },
    marketing: { name: 'Trženje', purpose: 'Podpirajo oglaševanje in trženje, ki ga izbere organizator.' }
  }
};

export default locale;
